<nz-skeleton [nzActive]="true" [nzLoading]="!informationTeam"></nz-skeleton>
<div
  *ngIf="informationTeam"
  class="bg-white rounded-10 p-5 max-sm:p-3 text-16 max-sm:text-12 font-roboto-400 flex flex-col gap-5"
>
  <div
    *ngIf="
      informationTeam.foundation_time && informationTeam.foundation_time > 0
    "
    class="flex justify-between items-center"
  >
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="calendar"
          [src]="urlSVG + 'calendar.svg'"
          class="max-sm:w-[15px]"
        />
      </div>
      {{ "FoundatinoYear" | translate | uppercase }}:
    </div>
    <span class="font-roboto-800 text-blue">
      {{ informationTeam.foundation_time }}
    </span>
  </div>

  <div
    class="flex justify-between items-center"
    *ngIf="informationTeam.venue_id"
  >
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="map"
          [src]="urlIMG + 'map.png'"
          class="w-[20px] max-sm:w-[15px]"
        />
      </div>
      {{ "Location" | translate | uppercase }}:
    </div>
    <span class="font-roboto-800 text-blue">
      {{ informationTeam.venue_name }} ({{ informationTeam.venue_city }})
    </span>
  </div>

  <div
    class="flex justify-between items-center"
    *ngIf="informationTeam.market_value > 0"
  >
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="bank"
          [src]="urlIMG + 'bank.png'"
          class="w-[20px] max-sm:w-[15px]"
        />
      </div>
      {{ "MarketValue" | translate | uppercase }}:
    </div>
    <span class="font-roboto-800 text-blue">
      {{ informationTeam.market_value_currency }}
      {{ informationTeam.market_value | number : "1.0-0" }}
    </span>
  </div>

  <div class="flex justify-between items-center">
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="goal"
          [src]="urlIMG + 'goal.png'"
          class="w-[20px] max-sm:w-[15px]"
        />
      </div>
      {{ "League" | translate | uppercase }}:
    </div>
    <div class="flex gap-2 items-center font-roboto-800 text-blue">
      {{ informationTeam.competition?.name }}
      <img
        alt="competition-logo"
        [src]="
          informationTeam.competition?.logo
            ? informationTeam.competition.logo
            : urlIMG + 'default.png'
        "
        class="max-w-[20px] max-sm:w-[15px]"
      />
    </div>
  </div>

  <div class="flex justify-between items-center">
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="globe"
          [src]="urlIMG + 'globe.png'"
          class="w-[20px] max-sm:w-[15px]"
        />
      </div>
      {{ "Country" | translate | uppercase }}:
    </div>
    <div class="flex gap-2 items-center font-roboto-800 text-blue">
      {{
        currentLanguage === "es"
          ? informationTeam.country_es
          : informationTeam.country
      }}
      <img
        alt="country_logo"
        [src]="informationTeam.country_logo"
        class="max-w-[20px] max-sm:w-[15px]"
      />
    </div>
  </div>

  <div class="flex justify-between items-center">
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <img
          alt="user"
          [src]="urlIMG + 'user.png'"
          class="w-[20px] max-sm:w-[15px]"
        />
      </div>
      {{ "Coach" | translate | uppercase }}:
    </div>
    <div class="flex gap-2 items-center font-roboto-800 text-blue">
      {{ informationTeam.coach?.name }}
      <img
        alt="coach"
        [src]="informationTeam.coach?.logo"
        class="max-w-[20px] max-sm:w-[15px]"
      />
    </div>
  </div>

  <div
    class="bg-red-4 font-roboto-500 text-16 rounded-5 p-5 text-grey-1 mb-3 max-sm:text-13 max-sm:p-3 max-sm:mb-0"
  >
    {{ "Team" | translate }}
  </div>

  <app-lineup [idTeam]="informationTeam.id"></app-lineup>
</div>
